<script>
import AvatarStyleText from '~/components/decks/avatar-style/AvatarStyleText'
import AvatarStyleNone from '~/components/decks/avatar-style/AvatarStyleNone'
import TooltipSelectorMixin from '~/components/decks/tooltip-selector/TooltipSelectorMixin'
import { avatarStyles } from '~/common/avatars'

const { FRIENDLY, BUSINESS, TEXT, NONE } = avatarStyles

export default {
  name: 'AvatarStyleSelector',
  mixins: [TooltipSelectorMixin],
  data () {
    return {
      options: [
        { id: FRIENDLY, label: 'Friendly', emoji: '/emoji/1f60a.svg' },
        { id: BUSINESS, label: 'Professional', emoji: '/emoji-business/id-card.svg', isPro: true, isInverse: true },
        { id: TEXT, label: 'Text Only', component: AvatarStyleText, isPro: true },
        { id: NONE, label: 'Anonymous', component: AvatarStyleNone, isPro: true }
      ]
    }
  }
}
</script>
